import { useState } from "react";
import { GuestCheckoutModal } from "~/feature/cart/B2CCart/components/GuestCheckoutDialog/GuestCheckoutDialog";
import { userIsRegistered } from "~/utils/roles";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { CART_STEP_3 } from "~/utils/url/staticUrls";
import { updateSalesPartner } from "~/SalesPartner/api/updateSalesPartner";
import type { GuestCheckoutFormData } from "~/feature/cart/B2CCart/components/GuestCheckoutDialog/components/GuestCheckoutFormModal";
import { submitGuestCheckoutForm } from "~/feature/cart/B2CCart/components/GuestCheckoutDialog/api/guestCheckoutSubmitForm";

export const useGuestCheckoutDialog = () => {
  const [open, setOpen] = useState(false);

  const onSubmit = async (formData: GuestCheckoutFormData) => {
    const response = await submitGuestCheckoutForm(formData);
    if (response.ok) {
      redirectToUrl(CART_STEP_3);
    } else {
      console.log(response.status);
      console.log(await response.text());
    }
    setOpen(false);
  };

  const dialog = <GuestCheckoutModal open={open} onClose={() => setOpen(false)} onSubmit={onSubmit} />;

  const handleCheckoutClick = async (subsidiaryId: string) => {
    await updateSalesPartner(subsidiaryId);
    if (userIsRegistered()) {
      redirectToUrl(CART_STEP_3);
    } else {
      setOpen(true);
    }
  };

  return [handleCheckoutClick, dialog] as const;
};
